/**
 * ProHabbo
 *
 * Henrique Arthur <eu@henriquearthur.com.br>
 */

Main = {
    plugins: {
        ellipsis: function () {
            el = (typeof el === 'undefined') ? false : el;

            if (!el) {
                $('.ell').ellipsis();
            } else {
                // Makes it faster
                el.find('.ell').ellipsis();
            }
        },
        tooltip: function () {
            $('[title]').tooltip();
        },
        marquee: function () {
            $('.partners-marquee').marquee({
                duration: 15000,
                gap: 50,
                delayBeforeStart: 0,
                direction: 'left',
                duplicated: true
            });
        },
        vis: (function () {
            var stateKey, eventKey, keys = {
                hidden: "visibilitychange",
                webkitHidden: "webkitvisibilitychange",
                mozHidden: "mozvisibilitychange",
                msHidden: "msvisibilitychange"
            };

            for (stateKey in keys) {
                if (stateKey in document) {
                    eventKey = keys[stateKey];
                    break;
                }
            }

            return function (c) {
                if (c) document.addEventListener(eventKey, c);

                return !document[stateKey];
            };
        })(),
        init: function () {
            Main.plugins.ellipsis();
            Main.plugins.tooltip();
            Main.plugins.marquee();
        }
    },
    checkAdblock: function () {
        var box = $("section.publicity .box-publicity");

        if (!Cookies.get('adblocked_message_closed')) {
            if (box.height() == 0) {
                $(".adblock-disable-button").on('click', function () {
                    swal({
                        title: 'Como desabilitar o AdBlock?',
                        type: 'info',
                        html: '<b>AdBlock Plus</b><br>' +
                            '1) Clique no ícone do AdBlock Plus, localizado à direita da barra de endereços do seu navegador<br>' +
                            '2) Um menu drop-down aparecerá na tela<br>' +
                            '3) Clique em “Enabled on this site” para desativar o bloqueio da publicidade<br>' +
                            '4) Após o clique, o texto será substituído por “Disabled on this site”<br>' +
                            '5) Recarregue a página que você estava tentando acessar<br><br>' +
                            '<b>AdBlock</b><br>' +
                            '1) Clique no ícone do AdBlock Pro, localizado à direita da barra de endereços do seu navegador<br>' +
                            '2) Um menu drop-down aparecerá na tela<br>' +
                            '3) Clique em “Don’t run on pages on this domain” para desativar o bloqueio da publicidade<br>' +
                            '4) Uma nova janela abrirá e você precisará clicar no botão “Exclude”<br>' +
                            '5) Após o clique, a página será recarregada<br>',
                        showCloseButton: true,
                        confirmButtonClass: 'btn btn-outline-info',
                        confirmButtonText: 'Beleza!',
                    });
                });

                $(".adblock-close-message").on('click', function () {
                    $(".box-publicity-blocked").fadeOut();

                    Cookies.set('adblocked_message_closed', true);
                });

                $(".box-publicity-blocked").fadeIn();
            }
        } else {
            console.log("Ei você aí! Será que rola desabilitar esse AdBlock? :(");
        }
    },
    search: {
        init: function () {
            $(".search-button").on('click', function () {
                $(".search-box").animateCss('lightSpeedIn').show();
            });

            $(".search-close").on('click', function () {
                $(".search-box").animateCss('lightSpeedOut', function () {
                    $(".search-box").hide();
                });
            });
        }
    },
    menu: {
        init: function () {
            $(".menu-link-wrapper > div.link").on('click', function () {
                var el = $(this);
                var id = el.data('id');

                var $original = $(el[0].outerHTML).addClass('active');
                var original = $original[0].outerHTML;

                $(".menu-link-wrapper > .link").hide('slide', {
                    'direction': 'down'
                }, function () {
                    $(this).css('display', 'none');

                    var html = original + el.find('.submenu').html();

                    $(".menu-link-wrapper .submenu-area").html(html).show('slide', {
                        'direction': 'up'
                    }, function () {
                        $(this).addClass('show');
                    });
                });
            });

            $(".submenu-area").on('click', '> div.link', function () {
                var area = $(this).parent();

                console.log('clicked on submenu');

                area.hide('slide', {
                    'direction': 'up'
                }, function () {
                    $(this).removeClass('show');

                    $(".menu-link-wrapper > .link").fadeIn();
                });
            });

            $(".user-menu-toggle").on('click', function () {
                var list = $(".user-menu-list");

                if (list.css('display') == 'none') {
                    list.animateCss('flipInX').show();
                } else {
                    list.animateCss('flipOutX', function () {
                        list.hide();
                    });
                }
            });
        }
    },
    lastTweet: {
        init: function () {
            $.ajax({
                url: '/a/getLastTweet',
                type: 'get',
                dataType: 'json'
            }).done(function (data) {
                var html = '<a href="' + data.link + '" target="_blank" class="text-truncate">' + data.tweet + '</a>';

                $(".last-tweet-text").html(html);
            });
        }
    },
    slide: {
        init: function () {
            $("#header-slider").lightSlider({
                item: 1,
                auto: true,
                loop: true,
                gallery: true,
                pause: 4000,
                keyPress: false,
                enableDrag: false,
                controls: false,
                vThumbWidth: 100,
                thumbItem: 10
            });
        }
    },
    content: {
        topMessages: {
            open: function () {
                var html = '';

                html += '<form class="form-user-send-message">';
                html += '<div class="form-group">';
                html += '<label>Mensagem</label>';
                html += '<textarea class="form-control" name="message" placeholder="Digite sua mensagem"></textarea>';
                html += '</div>';
                html += '<center><button type="submit" class="form-submit">Enviar</button></center>';
                html += '</form>';

                Alertbox({
                    title: "Enviar mensagem",
                    content: html,
                    type: 'misc'
                });
            },
            send: function (e) {
                e.preventDefault();

                var form = $(this);

                if (form.hasClass('disabled')) {
                    return false;
                }

                var message = form.find('textarea[name="message"]').val();

                if (message == '') {
                    form.effect('shake', { distance: 3 });
                } else {
                    form.addClass('disabled').animate({ 'opacity': 0.5 });

                    $.ajax({
                        url: '/a/sendTopMessage',
                        type: 'POST',
                        dataType: 'json',
                        data: { 'message': message },
                    }).done(function (data) {
                        form.removeClass('disabled').animate({ 'opacity': 1 });

                        if (data.status == 'error') {
                            var message = "";

                            for (i = data.messages.length - 1; i >= 0; i--) {
                                message += data.messages[i];

                                if (i > 0) {
                                    message += '<br>';
                                }
                            }

                            Alertbox({
                                title: "Erro ao enviar mensagem",
                                content: message,
                                type: 'error'
                            });
                        } else {
                            $.fancybox.close();

                            Alertbox({
                                title: 'Enviado com sucesso!',
                                content: "Sua mensagem foi enviada com sucesso. Após revisão da nossa moderação, ela estará disponível no site!",
                                type: 'success'
                            });
                        }
                    });
                }
            }
        },
        habboContent: {
            processSearch: function (e) {
                e.preventDefault();

                var text = $(this).find('input[type="text"]').val();

                if ($('[data-content-search="habboContent/badges"]').length == 0) {
                    var form1 = '<form style="opacity: 0;" data-content-search="habboContent/badges" data-receiver=".habbo-content-badges-list"><input type="text" value="' + text + '"></form>';
                    var form2 = '<form style="opacity: 0;" data-content-search="habboContent/images" data-receiver=".habbo-content-images-list"><input type="text" value="' + text + '"></form>';
                    var form3 = '<form style="opacity: 0;" data-content-search="habboContent/icons" data-receiver=".habbo-content-icons-list"><input type="text" value="' + text + '"></form>';
                    var form4 = '<form style="opacity: 0;" data-content-search="habboContent/furni" data-receiver=".habbo-content-furni-list"><input type="text" value="' + text + '"></form>';

                    $("body").append(form1 + form2 + form3 + form4);
                } else {
                    $('[data-content-search="habboContent/badges"]').find('input[type="text"]').val(text);
                    $('[data-content-search="habboContent/images"]').find('input[type="text"]').val(text);
                    $('[data-content-search="habboContent/icons"]').find('input[type="text"]').val(text);
                    $('[data-content-search="habboContent/furni"]').find('input[type="text"]').val(text);
                }

                $('[data-content-search="habboContent/badges"]').contentSearch().submit();
                $('[data-content-search="habboContent/images"]').contentSearch().submit();
                $('[data-content-search="habboContent/icons"]').contentSearch().submit();
                $('[data-content-search="habboContent/furni"]').contentSearch().submit();
            },
            changePeriodFirstArea: function (e) {
                var el = $(this);

                el.parent().find('.dropdown-item').removeClass('active');
                el.addClass('active');

                var text = el.text();
                $(".habbo-content-first-area-period-active").text(text);

                var time = el.data('time');

                var paginate;

                var paginates = [
                    "[data-paginate='habboContent/badges']",
                    "[data-paginate='habboContent/icons']"
                ];

                for (var i = paginates.length - 1; i >= 0; i--) {
                    paginate = $(paginates[i]);

                    paginate.data('time', time);

                    if (paginate.find('.paginate-update').length == 0) {
                        paginate.append('<div class="d-none paginate-update"></div>');
                    }

                    paginate.find('.paginate-update').click();
                }
            },
            changePeriodSecondArea: function (e) {
                var el = $(this);

                el.parent().find('.dropdown-item').removeClass('active');
                el.addClass('active');

                var text = el.text();
                $(".habbo-content-second-area-period-active").text(text);

                var time = el.data('time');

                var paginate;

                var paginates = [
                    "[data-paginate='habboContent/images']",
                    "[data-paginate='habboContent/furni']"
                ];

                for (var i = paginates.length - 1; i >= 0; i--) {
                    paginate = $(paginates[i]);

                    paginate.data('time', time);

                    if (paginate.find('.paginate-update').length == 0) {
                        paginate.append('<div class="d-none paginate-update"></div>');
                    }

                    paginate.find('.paginate-update').click();
                }
            }
        },
        events: {
            markPresence: function () {
                var button = $(this);

                if (button.hasClass('disabled')) {
                    return false;
                }

                var id = button.data('id');

                $.ajax({
                    url: '/a/recentEvents/markPresence',
                    type: 'POST',
                    dataType: 'json',
                    data: { 'id': id },
                }).done(function (data) {
                    if (data.status == 'error') {
                        var message = "";

                        for (i = data.messages.length - 1; i >= 0; i--) {
                            message += data.messages[i];

                            if (i > 0) {
                                message += '<br>';
                            }
                        }

                        Alertbox({
                            title: "Erro ao marcar presença",
                            content: message,
                            type: 'error'
                        });
                    } else if (data.status == 'success') {
                        button.toggleClass('active');
                    }
                });
            }
        },
        videos: {
            open: function () {
                var box = $(this).closest('.box-video');

                var pos = box.data('pos');
                var youtubeId = box.data('youtube-id');

                $(".video-embed-box-area").removeClass('triangle-one triangle-two triangle-thee');

                if (pos == 1) {
                    $(".video-embed-box-area").addClass('triangle-one');
                } else if (pos == 2) {
                    $(".video-embed-box-area").addClass('triangle-two');
                } else if (pos == 3) {
                    $(".video-embed-box-area").addClass('triangle-three');
                }

                $(".video-embed-box").html('<iframe type="text/html" style="width: 100%;" height="346" src="http://www.youtube.com/embed/' + youtubeId + '?autoplay=1" frameborder="0"></iframe>');
            }
        },
        arts: {
            changePeriod: function (e) {
                var el = $(this);

                el.parent().find('.dropdown-item').removeClass('active');
                el.addClass('active');

                var text = el.text();
                $(".arts-period-active").text(text);

                var time = el.data('time');

                var paginate;

                var paginates = [
                    "[data-paginate='recentArts']"
                ];

                for (var i = paginates.length - 1; i >= 0; i--) {
                    paginate = $(paginates[i]);

                    paginate.data('time', time);

                    if (paginate.find('.paginate-update').length == 0) {
                        paginate.append('<div class="d-none paginate-update"></div>');
                    }

                    paginate.find('.paginate-update').click();
                }
            }
        },
        rankings: {
            changeType: function (e) {
                var el = $(this);

                el.parent().find('.dropdown-item').removeClass('active');
                el.addClass('active');

                var text = el.text();
                $(".rankings-type-active").text(text);

                var type = el.data('type');

                var paginate;

                var paginates = [
                    "[data-paginate='rankings']"
                ];

                for (var i = paginates.length - 1; i >= 0; i--) {
                    paginate = $(paginates[i]);

                    paginate.data('type', type);

                    if (paginate.find('.paginate-update').length == 0) {
                        paginate.append('<div class="d-none paginate-update"></div>');
                    }

                    paginate.find('.paginate-update').click();
                }
            }
        },
        init: function () {
            $(".user-send-message").on('click', Main.content.topMessages.open);
            $(document).on('submit', '.form-user-send-message', Main.content.topMessages.send);

            $(".habbo-content-search-form").on('submit', Main.content.habboContent.processSearch);

            $(".habbo-content-first-area-period-dropdown").on('click', '.dropdown-item', Main.content.habboContent.changePeriodFirstArea);
            $(".habbo-content-second-area-period-dropdown").on('click', '.dropdown-item', Main.content.habboContent.changePeriodSecondArea);

            $(".paginate-recent-articles").paginate({
                onChangePage: function () {
                    Main.plugins.tooltip();
                }
            });

            $(".paginate-habbo-content-badges").paginate({
                onChangePage: function () {
                    Main.plugins.tooltip();
                }
            });

            $(".paginate-habbo-content-icons").paginate({
                onChangePage: function () {
                    Main.plugins.tooltip();
                }
            });

            $(".paginate-habbo-content-images").paginate({
                onChangePage: function () {
                    Main.plugins.tooltip();
                }
            });

            $(".paginate-habbo-content-furni").paginate({
                onChangePage: function () {
                    Main.plugins.tooltip();
                }
            });

            $(".paginate-recent-articles").paginate({
                onChangePage: function () {
                    Main.plugins.tooltip();
                }
            });

            $(".paginate-habbo-content-badges").paginate({
                onChangePage: function () {
                    Main.plugins.tooltip();
                }
            });

            $(".paginate-habbo-content-icons").paginate({
                onChangePage: function () {
                    Main.plugins.tooltip();
                }
            });

            $(".paginate-habbo-content-images").paginate({
                onChangePage: function () {
                    Main.plugins.tooltip();
                }
            });

            $(".paginate-habbo-content-furni").paginate({
                onChangePage: function () {
                    Main.plugins.tooltip();
                }
            });

            $(".paginate-forum-topics").paginate({
                onChangePage: function () {
                    Main.plugins.tooltip();
                }
            });

            $(".paginate-free-items").paginate({
                onChangePage: function () {
                    Main.plugins.tooltip();
                }
            });

            $(".paginate-columns").paginate({
                onChangePage: function () {
                    Main.plugins.tooltip();
                }
            });

            $(".paginate-interviews").paginate({
                onChangePage: function () {
                    Main.plugins.tooltip();
                }
            });

            $(".paginate-pop-world").paginate({
                onChangePage: function () {
                    Main.plugins.tooltip();
                }
            });

            $(".paginate-events").paginate({
                onChangePage: function () {
                    Main.plugins.tooltip();
                }
            });

            $(".paginate-recent-videos").paginate({
                onChangePage: function () {
                    Main.plugins.tooltip();
                }
            });

            $(".paginate-recent-arts").paginate({
                onChangePage: function () {
                    Main.plugins.tooltip();
                }
            });

            $(".arts-period-dropdown").on('click', '.dropdown-item', Main.content.arts.changePeriod);

            $(".paginate-rankings").paginate({
                onChangePage: function () {
                    Main.plugins.tooltip();
                }
            });

            $(".rankings-type-dropdown").on('click', '.dropdown-item', Main.content.rankings.changeType);

            $(".paginate-recent-records").paginate({
                onChangePage: function () {
                    Main.plugins.tooltip();
                }
            });

            $(".paginate-recent-builders").paginate({
                onChangePage: function () {
                    Main.plugins.tooltip();
                }
            });

            $(".paginate-recommended-rooms").paginate({
                onChangePage: function () {
                    Main.plugins.tooltip();
                }
            });

            /*
            $(".paginate-recent-comics").paginate({
                onChangePage: function() {
                    Main.plugins.tooltip();
                }
            });
            */

            $(".content-search-articles").contentSearch();
            $(".content-search-columns").contentSearch();
            $(".content-search-interviews").contentSearch();
            $(".content-search-videos").contentSearch();
            $(".content-search-arts").contentSearch();
            $(".content-search-topics").contentSearch();
            //$(".content-search-comics").contentSearch();

            $(".content-select-category-articles").contentSelectCategory();
            $(".content-select-category-videos").contentSelectCategory();

            $(".events-list").on('click', '.box-event .button-presence', Main.content.events.markPresence);
            $(".recent-videos-list").on('click', ' .box-video .video-open', Main.content.videos.open);
        }
    },
    init: function () {
        Main.plugins.init();

        Main.menu.init();
        Main.search.init();
        Main.lastTweet.init();
        Main.slide.init();

        Main.content.init();
    }
};

$(document).ready(function () {
    Main.init();
});

$(window).on('load', function () {
    Main.checkAdblock();
});

$.fn.extend({
    animateCss: function (animationName, callback) {
        var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        this.addClass('animated ' + animationName).one(animationEnd, function () {
            $(this).removeClass('animated ' + animationName);

            if (callback) {
                callback();
            }
        });
        return this;
    }
});
